var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_9957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9493 9.23943C15.6537 9.12216 15.1849 8.99268 14.6052 8.99268C13.1252 8.99268 12.0831 9.78186 12.0767 10.9102C12.0644 11.7426 12.8228 12.205 13.3901 12.4825C13.9699 12.7662 14.167 12.9513 14.167 13.2041C14.1611 13.5924 13.6985 13.7714 13.267 13.7714C12.6687 13.7714 12.3481 13.6791 11.8609 13.4631L11.6635 13.3705L11.4538 14.6715C11.8053 14.8317 12.4529 14.9738 13.1252 14.98C14.6977 14.98 15.7214 14.203 15.7335 13.0006C15.7395 12.3408 15.339 11.8353 14.4756 11.4222C13.9514 11.157 13.6304 10.9782 13.6304 10.7068C13.6366 10.4602 13.9019 10.2075 14.4936 10.2075C14.9808 10.1951 15.3388 10.3122 15.61 10.4294L15.7455 10.491L15.9493 9.23943Z",
    fill: "url(#paint0_linear_254_9957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5167 14.8936H9.01802L9.95537 9.09774H11.4539L10.5167 14.8936Z",
    fill: "url(#paint1_linear_254_9957)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.791 9.09774H18.6318C18.2743 9.09774 18.0027 9.20247 17.8485 9.57862L15.6225 14.8935H17.195C17.195 14.8935 17.4538 14.1782 17.5095 14.0241H19.4336C19.4766 14.2276 19.6124 14.8935 19.6124 14.8935H21L19.791 9.09774ZM17.9411 12.8403C18.0645 12.5074 18.5394 11.2187 18.5394 11.2187C18.5369 11.2237 18.5562 11.1701 18.585 11.0903L18.5854 11.0893L18.5856 11.0887C18.6287 10.9694 18.6925 10.7924 18.7366 10.6638L18.8413 11.1632C18.8413 11.1632 19.1251 12.5506 19.1868 12.8403H17.9411Z",
    fill: "url(#paint2_linear_254_9957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76631 9.09774L6.29865 13.05L6.13828 12.2484L6.13813 12.2479L5.61412 9.58493C5.52783 9.21476 5.26263 9.10995 4.93582 9.09774H2.52467L2.5 9.21484C3.08807 9.36522 3.61404 9.58192 4.07491 9.85136L5.41064 14.8875H6.9954L9.35098 9.09774H7.76631Z",
    fill: "url(#paint3_linear_254_9957)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_254_9957",
    x1: 2.5,
    y1: 11.9989,
    x2: 21,
    y2: 11.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_254_9957",
    x1: 2.5,
    y1: 11.9989,
    x2: 21,
    y2: 11.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_254_9957",
    x1: 2.5,
    y1: 11.9989,
    x2: 21,
    y2: 11.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_254_9957",
    x1: 2.5,
    y1: 11.9989,
    x2: 21,
    y2: 11.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_9957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 5.98731,
    fill: "white",
    transform: "translate(2.5 8.99268)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogo2);
export default __webpack_public_path__ + "static/media/payment-logo-2.a50b502305583f8f518667e7f3d9d935.svg";
export { ForwardRef as ReactComponent };